export const COMPONENT_NAMES = {
  HUBSPOT_CREDITS_WITH_OVERAGES_TILE: {
    MAIN: 'HubSpotCreditsWithOveragesTile',
    TOOLTIP: 'HubSpotCreditsWithOveragesTileTooltip',
    CHART: 'HubSpotCreditsWithOveragesChart',
    CREDIT_USAGE_WELL_ITEM: 'CreditUsageWellItem',
    BUY_HUBSPOT_CREDITS_BUTTON: 'BuyHubSpotCreditsButton'
  },
  CREDIT_ESTIMATOR: {
    MAIN: 'CreditEstimator',
    TALK_TO_SALES: 'CreditEstimatorTalkToSales',
    CREATE_CUSTOM_PLAN: 'CreditEstimatorCreateCustomPlan'
  },
  ADVANCED_CREDIT_ESTIMATOR: {
    MAIN: 'AdvancedCreditEstimator',
    VIEW_DATA_HUB_PRICING: 'AdvancedCreditEstimatorViewDataHubPricing',
    VIEW_SALES_HUB_PRICING: 'AdvancedCreditEstimatorViewSalesHubPricing'
  },
  CREDIT_ICON_WITH_POPOVER: 'CreditIconWithPopover',
  CREDIT_ICON_WITH_TOOLTIP: 'CreditIconWithTooltip',
  NOTIFICATION_BANNER: 'NotificationBanner',
  HUBSPOT_CREDITS_CARD: {
    MAIN: 'HubSpotCreditsCard',
    LEARN_MORE_LINK: 'HubSpotCreditsCardLearnMoreLink',
    MANAGE_USER_PERMISSIONS_LINK: 'HubSpotCreditsCardManageUserPermissionsLink'
  },
  PERCENT_CREDITS_USED_WIDGET: 'PercentCreditsUsedWidget',
  CREDIT_STATUS_BANNER: {
    MAIN: 'CreditStatusBanner',
    CREDITS_REMAINING: 'CreditStatusBannerCreditsRemaining',
    FEATURE_USAGE: 'CreditStatusBannerFeatureUsage'
  },
  CREDIT_BALANCE_TEXT: {
    MAIN: 'CreditBalanceText',
    TOOLTIP: 'CreditBalanceTextTooltip'
  },
  CREDIT_BALANCE_CONTENT: {
    MAIN: 'CreditBalanceContent',
    CTA: 'CreditBalanceContentCTA',
    CANCEL: 'CreditBalanceContentCancel'
  },
  CREDIT_BALANCE_POPOVER: 'CreditBalancePopover',
  CREDIT_BALANCE_INFO_BOX: 'CreditBalanceInfoBox',
  CURRENT_USAGE: {
    CONTAINER: {
      MAIN: 'CurrentUsageContainer',
      TOOLTIP: 'CurrentUsageContainerTooltip',
      REFRESH_BUTTON: 'CurrentUsageContainerRefreshButton'
    },
    CHART: 'CurrentUsageChart'
  },
  CURRENT_USAGE_SUMMARY: {
    CONTAINER: 'CurrentUsageSummaryContainer',
    WELL_ITEM: 'CurrentUsageSummaryWellItem'
  },
  HISTORICAL_USAGE: {
    CONTAINER: {
      MAIN: 'HistoricalUsageContainer',
      TIME_FRAME_PICKER: 'HistoricalUsageContainerTimeFramePicker',
      NON_BILLED_USAGE_TOGGLE: 'HistoricalUsageContainerNonBilledUsageToggle'
    },
    CHART: 'HistoricalUsageChart'
  },
  USAGE_LOG: {
    CONTAINER: 'UsageLogContainer',
    TABLE: 'UsageLogTable',
    DATE_RANGE_PICKER: 'UsageLogDateRangePicker',
    RATE_SHEET_LINK: 'UsageLogRateSheetLink',
    TOOLTIP: 'UsageLogTooltip'
  },
  FEATURE_TYPE_USAGE_BY_ACTION_CARD: {
    RATE_SHEET_LINK: 'FeatureTypeUsageByActionCardRateSheetLink'
  },
  MANAGE_FEATURE_USAGE_TABLE: {
    MAIN: 'ManageFeatureUsageTable',
    FEATURE_TYPE_ROW: 'ManageFeatureUsageTableFeatureTypeRow'
  },
  USAGE_ALLOWANCE_CARD: {
    MAIN: 'UsageAllowanceCard'
  },
  USAGE_ALLOWANCE_FEATURE_CARD: {
    MAIN: 'UsageAllowanceFeatureCard',
    LINK: 'UsageAllowanceFeatureCardLink'
  },
  YOUR_CREDITS_CARD: {
    MAIN: 'YourCreditsCard',
    TOOLTIP: 'YourCreditsCardTooltip',
    ADD_CREDITS_LINK: 'YourCreditsCardAddCreditsLink',
    MANAGE_CREDIT_SETTINGS: 'YourCreditsCardManageCreditSettings',
    MAXIMUM_MONTHLY_CREDITS: {
      ADD_MORE_CREDITS_LINK: 'YourCreditsCardAddMoreCreditsLink',
      EDIT_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditEditButton',
      MODAL: 'YourCreditsCardEditMaximumMonthlyCreditModal',
      MODAL_CANCEL_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditModalCancelButton',
      MODAL_CONFIRM_BUTTON: 'YourCreditsCardEditMaximumMonthlyCreditModalConfirmButton'
    },
    OVERAGE_SETTING: {
      EDIT_BUTTON: 'YourCreditsCardEditOverageSettingEditButton',
      MODAL: 'YourCreditsCardEditOverageSettingModal',
      MODAL_AUTO_UPGRADE_OPTION: 'YourCreditsCardEditOverageSettingModalAutoUpgradeOption',
      MODAL_PAY_AS_YOU_GO_OPTION: 'YourCreditsCardEditOverageSettingModalPayAsYouGoOption',
      MODAL_CANCEL_BUTTON: 'YourCreditsCardEditOverageSettingModalCancelButton',
      MODAL_CONFIRM_BUTTON: 'YourCreditsCardEditOverageSettingModalConfirmButton',
      MODAL_CANCEL_SCHEDULED_CHANGE_BUTTON: 'YourCreditsCardEditOverageSettingModalCancelScheduledChangeButton'
    },
    FEATURE_CREDIT_LIMITS: {
      VIEW_BUTTON: 'YourCreditsCardFeatureCreditLimitsViewButton',
      VIEW_LIMITS_BUTTON: 'YourCreditsCardFeatureCreditLimitsViewLimitsButton'
    }
  },
  FEATURE_PAUSED_POPOVER: {
    MAIN: 'FeaturePausedPopover',
    CTA: 'FeaturePausedPopoverCTA'
  },
  USES_CREDITS_LABEL: {
    MAIN: 'UsesCreditsLabel',
    POPOVER: 'UsesCreditsPopover',
    TOOLTIP: 'UsesCreditsTooltip'
  },
  CREDIT_FOOTER_ALERT: 'CreditFooterAlert',
  CREDIT_FOOTER_ALERT_V2: {
    MAIN: 'CreditFooterAlertV2',
    EDIT_LIMIT_CTA: 'CreditFooterAlertV2EditLimitCta',
    VIEW_USAGE_CTA: 'CreditFooterAlertV2ViewUsageCta',
    SET_LIMIT_CTA: 'CreditFooterAlertV2SetLimitCta',
    MANAGE_CREDITS_CTA: 'CreditFooterAlertV2ManageCreditsCta',
    ADD_CREDITS_CTA: 'CreditFooterAlertV2AddCreditsCta',
    REQUEST_CREDITS_CTA: 'CreditFooterAlertV2RequestCreditsCta',
    BUY_CREDITS_CTA: 'CreditFooterAlertV2BuyCreditsCta',
    LEARN_MORE_LINK: 'CreditFooterAlertV2LearnMoreLink',
    OPEN_MODAL_BUTTON: 'CreditFooterAlertV2OpenModalButton'
  },
  CREDIT_FOOTER: 'CreditFooter',
  CREDITS_CTA: 'CreditsCTA',
  MANAGE_CREDIT_SETTINGS_CTA: 'ManageCreditSettingsCta',
  CREDIT_BILLING_WIZARD: {
    DONE_BUTTON: 'CreditBillingWizardDoneButton',
    OVERAGE_SETTING_SELECTION: 'CreditBillingWizardOverageSettingSelection',
    CREDIT_SPEND_LIMIT_SELECTION: 'CreditBillingWizardCreditSpendLimitSelection'
  },
  MONETIZATION_STATUS_ALERT: 'MonetizationStatusAlert',
  MONETIZATION_STATUS_ICON: 'MonetizationStatusIcon',
  BETA: {
    BADGE: 'BetaBadge'
  },
  FEATURE_TYPE_OVERVIEW_PAGE: {
    STATUS_CHANGE_BUTTON: 'FeatureTypeOverviewPageStatusChangeButton',
    BACK_BUTTON: 'FeatureTypeOverviewPageBackButton'
  },
  FEATURE_TYPE_USAGE_CARD: {
    STATUS_CHANGE_BUTTON: 'FeatureTypeUsageCardStatusChangeButton',
    STATUS_CHANGE_CONFIRMATION_MODAL: 'FeatureTypeUsageCardStatusChangeConfirmationModal',
    STATUS_CHANGE_CONFIRMATION_MODAL_CONFIRM_BUTTON: 'FeatureTypeUsageCardStatusChangeConfirmationModalConfirmButton',
    STATUS_CHANGE_CONFIRMATION_MODAL_VIEW_ALL_WORKFLOWS_LINK: 'FeatureTypeUsageCardStatusChangeConfirmationModalViewAllWorkflowsLink',
    VIEW_SOURCE_LINK: 'FeatureTypeUsageCardViewSourceLink'
  },
  FEATURE_TYPE_USAGE_TOGGLE_CONTAINER: {
    TOGGLE: 'FeatureTypeUsageToggleToggle'
  },
  FEATURE_SPEND_LIMIT_CARD: {
    SET_LIMIT_BUTTON: 'FeatureSpendLimitCardSetLimitButton',
    EDIT_LIMIT_BUTTON: 'FeatureSpendLimitCardEditLimitButton',
    REMOVE_LIMIT_BUTTON: 'FeatureSpendLimitCardRemoveLimitButton',
    CANCEL_BUTTON: 'FeatureSpendLimitCardCancelButton',
    SAVE_BUTTON: 'FeatureSpendLimitCardSaveButton'
  },
  FEATURE_CREDITS_SETTINGS_CARD: {
    MAIN: 'FeatureCreditsSettingsCard',
    ADD_CREDITS_BUTTON: 'FeatureCreditsSettingsCardAddCreditsButton',
    VIEW_FEATURE_LINK: 'FeatureCreditsSettingsCardViewFeatureLink'
  },
  ACTION_MONETIZATION_ALERT: {
    MAIN: 'ActionMonetizationAlert',
    LEARN_MORE_LINK: 'ActionMonetizationAlertLearnMoreLink'
  },
  FEATURE_MONETIZATION_ALERT: {
    MAIN: 'FeatureMonetizationAlert',
    LEARN_MORE_LINK: 'FeatureMonetizationAlertLearnMoreLink'
  },
  FREE_ACCESS_CARD: {
    MAIN: 'FreeAccessCard',
    USAGE_LIMITS_LINK: 'FreeAccessCardUsageLimitsLink'
  },
  FEATURE_TYPE_HISTORICAL_USAGE_CARD: {
    MAIN: 'FeatureTypeHistoricalUsageCard',
    NON_BILLED_USAGE_TOGGLE: 'FeatureTypeHistoricalUsageCardNonBilledUsageToggle',
    REFRESH_BUTTON: 'FeatureTypeHistoricalUsageCardRefreshButton',
    TOOLTIP: 'FeatureTypeHistoricalUsageCardTooltip'
  },
  FEATURE_TYPE_FREE_ACCESS_USAGE_CARD: {
    MAIN: 'FeatureTypeFreeAccessUsageCard',
    LEARN_MORE_LINK: 'FeatureTypeFreeAccessUsageCardLearnMoreLink',
    BUTTON: 'FeatureTypeFreeAccessUsageCardButton'
  },
  FREE_ACCESS_BANNER: {
    MAIN: 'FreeAccessBanner',
    OPEN_MODAL_BUTTON: 'FreeAccessBannerOpenModalButton'
  },
  ACTIVATE_CREDITS_MODAL: {
    MAIN: 'ActivateCreditsModal',
    TOGGLE: 'ActivateCreditsModalToggle',
    SAVE_BUTTON: 'ActivateCreditsModalSaveButton',
    LEARN_MORE_LINK: 'ActivateCreditsModalLearnMoreLink',
    USAGE_AND_LIMITS_LINK: 'ActivateCreditsModalUsageAndLimitsLink'
  },
  USAGE_EDUCATION_POPOVER: {
    MAIN: 'UsageEducationPopover',
    TRIGGER: 'UsageEducationPopoverTrigger',
    RATE_SHEET_LINK: 'UsageEducationPopoverRateSheetLink',
    MANAGE_USAGE_BUTTON: 'UsageEducationPopoverManageUsageButton',
    CANCEL_BUTTON: 'UsageEducationPopoverCancelButton'
  },
  USAGE_INFO_POPOVER: {
    MAIN: 'UsageInfoPopover',
    TRIGGER: 'UsageInfoPopoverTrigger',
    FEATURE_LINK: 'UsageInfoPopoverFeatureLink',
    RATE_SHEET_LINK: 'UsageInfoPopoverRateSheetLink',
    MANAGE_USAGE_BUTTON: 'UsageInfoPopoverManageUsageButton'
  },
  USAGE_INFO_TEXT: {
    MAIN: 'UsageInfoText'
  },
  RATE_CARD_CHANGE_BANNER: {
    MAIN: 'RateCardChangeBanner'
  }
};
export const WELL_ITEM_TYPES = {
  SUBSCRIPTION_CREDITS_USED: 'SubscriptionCreditsUsed',
  OVERAGE_CREDITS_USED: 'OverageCreditsUsed',
  CURRENT_OVERAGE_COSTS: 'CurrentOverageCosts'
};
export const BILLING_ACTION_TYPES = {
  DISABLED: 'DISABLED',
  OVERAGE: 'OVERAGE',
  TIER_UPGRADE: 'TIER_UPGRADE'
};
export const FREE_ACCESS = {
  ENDING_SOON_THRESHOLD_DAYS: 4
};
export const FRONTEND_PREFERENCES_KEYS = {
  FREE_ACCESS_BANNER_LAST_STATE: 'UBB:FreeAccessBannerLastState',
  LAST_CREDIT_STATUS_BANNER_SEEN: 'UBB:LastCreditStatusBannerSeen',
  LAST_CREDIT_STATUS_BANNER_LIMIT_SEEN: 'UBB:LastCreditStatusBannerLimitSeen',
  MANAGE_FEATURE_USAGE_TABLE_FILTER: 'UBB:ManageFeatureUsageTableFilter',
  MANAGE_FEATURE_USAGE_TABLE_SORT: 'UBB:ManageFeatureUsageTableSort',
  USAGE_LOG_DATE_RANGE: 'UBB:UsageLogDateRange'
};